const $ = jQuery.noConflict();

export default function resetQuery() {
	$(document).ready(() => {
		$('.js-resetquery').click(function (e) {
			e.preventDefault();
			$('.search-field__input').val('').focus();
		});
	});
}
